import {lazy} from 'react';
import {Navigate, type RouteObject} from 'react-router-dom';

import withSuspense from '@/routes/withSuspense';

const User = lazy(() => import('@/pages/mngt/user/User'));
const UserList = lazy(() => import('@/pages/mngt/user/UserList'));

const userRoutes: RouteObject[] = [
  {
    path: '/mngt/user',
    element: withSuspense(<User />),
    children: [
      {
        index: true,
        element: <Navigate to="list" replace />
      },
      {
        path: 'list',
        element: withSuspense(<UserList />)
      }
    ]
  }
];

export default userRoutes;
